import React from 'react';

const IcoMoon = ({ glyph }) => (
  <span className={`icomoon icomoon--${glyph}`} />
);

export default IcoMoon;
